import React from 'react';
import './Loader.css';

const Loader = () => {
  return (
    <div className="loader-overlay">
      <div className="loader">
        <div className="loader-ring"></div>
      </div>
    </div>
  );
};

export default Loader;
